module.exports = __webpack_public_path__ + "static/alte-haas-bold-a4d22cf7fcb9e1f8966499e6a3a812a2.eot";